import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_fs_rec_12: FaireProductEntity = {
  token: "atc_updated_fs_rec_12",
  type: "product",
  name: "Geometric Pattern Vase with Flowers",
  brandName: "Faire Source",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/f02cbc77b7ceabac0663fe680ba588c49471c198df591792dfce43ea04e0dd43.webp",
  priceDollars: 36,
  msrpDollars: 48,
  description: "Recommended product for ATC flow.",
  tags: ["home", "design", "recommendations"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
